import { HttpApiError, HttpApiGroup } from "@effect/platform";
import { Schema } from "effect";
import { endpoint } from "../auth/endpoint";
import { DatabaseError, DataIntegrityError } from "../auth/errors";

export const DefaultRuleConfigResponse = Schema.Struct({
  defaultRuleId: Schema.String,
  enabled: Schema.Boolean,
  sortIndex: Schema.Number,
  configurations: Schema.Unknown,
});
export type DefaultRuleConfigResponse = typeof DefaultRuleConfigResponse.Type;

const GetDefaultRulesResponse = Schema.Struct({
  configs: Schema.Array(DefaultRuleConfigResponse),
});

const BatchUpdateDefaultRuleSortIndexesRequest = Schema.Struct({
  orders: Schema.Array(
    Schema.Struct({ defaultRuleId: Schema.String, sortIndex: Schema.Number }),
  ),
});

const UpdateDefaultRuleEnabledRequest = Schema.Struct({
  defaultRuleId: Schema.String,
  enabled: Schema.Boolean,
});

const UpdateDefaultRuleConfigurationsRequest = Schema.Struct({
  defaultRuleId: Schema.String,
  configurations: Schema.Unknown,
});

export const DefaultRuleGroup = HttpApiGroup.make("defaultRule")
  .add(
    endpoint.merchant
      .get("getDefaultRules", "/default-rules")
      .addSuccess(GetDefaultRulesResponse)
      .addError(HttpApiError.Forbidden)
      .addError(DatabaseError)
      .addError(DataIntegrityError),
  )
  .add(
    endpoint.merchant
      .post("batchUpdateDefaultRuleSortIndexes", "/default-rules/sort-indexes")
      .setPayload(BatchUpdateDefaultRuleSortIndexesRequest)
      .addSuccess(Schema.Void)
      .addError(HttpApiError.Forbidden)
      .addError(DatabaseError)
      .addError(DataIntegrityError),
  )
  .add(
    endpoint.merchant
      .post("updateDefaultRuleEnabled", "/default-rules/enabled")
      .setPayload(UpdateDefaultRuleEnabledRequest)
      .addSuccess(Schema.Void)
      .addError(HttpApiError.Forbidden)
      .addError(DatabaseError)
      .addError(DataIntegrityError),
  )
  .add(
    endpoint.merchant
      .post("updateDefaultRuleConfigurations", "/default-rules/configurations")
      .setPayload(UpdateDefaultRuleConfigurationsRequest)
      .addSuccess(Schema.Void)
      .addError(HttpApiError.Forbidden)
      .addError(DatabaseError)
      .addError(DataIntegrityError),
  )
  .prefix("/api");
